import { Component, AfterViewInit, ViewChild, ElementRef, Input, OnChanges } from '@angular/core';
import { GridOptions } from 'ag-grid';
import * as encoding from 'encoding-japanese';
import { ClientReportService } from '../../../service/client-report/client-report.service';
import { CommonService } from '../../../service/common/common.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';

@Component({
  selector: 'app-wa3014',
  templateUrl: './wa3014.component.html',
  styleUrls: ['./wa3014.component.scss']
})
export class Wa3014Component implements AfterViewInit, OnChanges {
  private gridApi: any;
  public componentTitle = 'WA3014:出荷欠品詳細照会';
  public updprogramCd = 'WA3014';
  private totalCount = 0;
  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];
  public config = config;
  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  private gridHelper: AgGridHelper;
  @Input() private window: string;

  @ViewChild('gridView')
  gridView: ElementRef;
  private isEnableClearFilter = false;

  constructor(private clientReportService: ClientReportService, private commonService: CommonService) {
    this.gridHelper = new AgGridHelper();
    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      pagination: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa3014_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
      },
      onFilterChanged: () => {
        this.gridHelper.onGridFilterChanged();
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.errorInfo = '';
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.gridHelper.fixedAgMenu();
        this.errorInfo = '';
      },
      onSortChanged: () => {
        this.gridHelper.renderGridCheckboxImage();
        this.errorInfo = '';
      },
      onPaginationChanged: () => {
        this.totalCount = this.gridOptions.api.paginationGetRowCount();
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        unSortIcon: true,
        width: this.getColumnWidth('ownerCd', 120),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        unSortIcon: true,
        width: this.getColumnWidth('ownerTx', 150),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        unSortIcon: true,
        width: this.getColumnWidth('itemCd', 120),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        unSortIcon: true,
        width: this.getColumnWidth('itemTx', 100),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロット',
        field: 'lotTx',
        unSortIcon: true,
        width: this.getColumnWidth('lotTx', 100),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '全指示数',
        field: 'allorderpcsNr',
        unSortIcon: true,
        width: this.getColumnWidth('allorderpcsNr', 100),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '在庫数',
        field: 'stockNr',
        unSortIcon: true,
        width: this.getColumnWidth('stockNr', 100),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '欠品数',
        field: 'shortNr',
        width: this.getColumnWidth('shortNr', 100),
        cellClass: ['tr', 'cellclass'],
        valueFormatter: insertcomma
      },
      {
        headerName: '届先コード',
        field: 'dtaddressCd',
        unSortIcon: true,
        width: this.getColumnWidth('dtaddressCd', 120),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先名',
        field: 'dtnameTx',
        unSortIcon: true,
        width: this.getColumnWidth('dtnameTx', 150),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '届先単位の指示数',
        field: 'orderpcsNr',
        unSortIcon: true,
        width: this.getColumnWidth('orderpcsNr', 140),
        cellClass: ['tl', 'cellclass'],
        valueFormatter: insertcomma
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa3014_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa3014_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa3014_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];
    return result;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    const shortsDetail: any = JSON.parse(sessionStorage.getItem('shortsDetail'));
    if (shortsDetail === null) {
      return;
    }
    this.rowData = shortsDetail;
    sessionStorage.removeItem('shortsDetail');
  }

  // クライアント帳票出力
  printClientReport(reportCd: string) {
    this.working = true;
    switch (reportCd) {
      case 'RA3007':
        break;
      default:
        this.working = false;
        this.errorInfo = '予期せぬエラー：未定義の帳票コードです';
        return;
    }
    let ownerId = 0;
    const selectIds: object[] = [];
    const selectItems: object[] = JSON.parse(sessionStorage.getItem('wa3010-checkShort-selectItems'));
    for (let i = 0; i < selectItems.length; i++) {
      // push data
      const jsonUnit: object = {
        selectId: selectItems[i]['shiphId']
      };
      selectIds.push(jsonUnit);
    }
    this.clientReportService
      .post(ownerId, reportCd, '', this.updprogramCd, selectIds)
      .then(outputJson => {
        this.working = false;
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  onsubmint() {
    this.onFilterClear();
    this.rowData = JSON.parse(sessionStorage.getItem('shortsDetail'));
  }

  ngOnChanges() {
    if (this.window) this.gridHelper.el = this.gridView;
    const shortsDetail: any = JSON.parse(sessionStorage.getItem('shortsDetail'));
    if (shortsDetail === null) {
      return;
    }
    this.rowData = shortsDetail;
    sessionStorage.removeItem('shortsDetail');
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa3Shipment/wa3014/wa3014.component.ts